module.exports = __webpack_public_path__ + "img/mesa_4.9adfbaaa.png";